import { type BatchProgress, type BatchUpdateBody, batchProgressSchema } from '@/types/batch';
import { INTERNAL_V1, damRequest } from '@/hooks/damRequest';

const BASE = `${INTERNAL_V1}/batch`;

const batchUpdate = async (body: BatchUpdateBody, token?: string) => {
  const response = await damRequest('POST', BASE, token, { body });
  return response;
};

const getBatchProgress = async (batchId: string, token?: string): Promise<BatchProgress> => {
  const response = await damRequest('GET', `${BASE}/${batchId}`, token);
  return batchProgressSchema.parse(response);
};

export { batchUpdate, getBatchProgress };
